/**
 * Nettoie une chaîne de caractères en supprimant :
 * - les caractères invisibles ASCII (non-imprimables),
 * - les caractères potentiellement dangereux (XSS/SQL).
 *
 * @param value La chaîne à nettoyer
 * @returns La chaîne nettoyée
 */
export function cleanInputValue(value: string | undefined): string {
  if (!value) return "";

  return value
    // Supprime les caractères invisibles sauf les retours à la ligne et les retours chariots
    .replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F]/g, "")  // Exclut \n et \r
    // Supprime les caractères suspects (potentiellement dangereux)
    .replace(/[<>[\]{}\\;]/g, "")
    // Supprime les doubles tirets (injection SQL classique)
    .replace(/--/g, "")
}